module.exports = __webpack_public_path__ + "static/media/Project2_Fig13.3dc06403.png";